/**
 * State of installment payment balance
 */
export type InstallmentPaymentBalanceStateType =
  (typeof InstallmentPaymentBalanceStateType)[keyof typeof InstallmentPaymentBalanceStateType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstallmentPaymentBalanceStateType = {
  PAID: 'PAID',
  TO_PAY: 'TO_PAY',
  UNPAID: 'UNPAID',
  CANCELLED: 'CANCELLED',
  UNDEFINED: 'UNDEFINED',
} as const;
